import React from "react";
import pattern from "../../../../../assets/pattern.jpg";
import { ViewportSize } from "../../types";

interface PreviewContainerProps {
    viewportSize: ViewportSize;
    getPreviewContainerStyle: () => React.CSSProperties;
    onClick?: () => void;
    children: React.ReactNode;
}

const PreviewContainer: React.FC<PreviewContainerProps> = ({
    viewportSize,
    getPreviewContainerStyle,
    onClick,
    children,
}) => {
    return (
        <div
            className="p-8 px-0 flex bg-white justify-center items-start min-h-screen"
            style={{
                backgroundImage: `url("${pattern}")`,
                backgroundRepeat: "repeat",
                backgroundSize: "50px 50px",
            }}
            onClick={onClick}>
            <div
                style={getPreviewContainerStyle()}
                className="w-full transition-all duration-300">
                {children}
            </div>
        </div>
    );
};

export default PreviewContainer;
